const XIDR_BIZ_TX_TYPES = ['deposit', 'withdrawal', 'stablecoin_deposit', 'stablecoin_withdrawal']

export const filterXIDRBizTxTypes = (txTypes: Array<{ label: string; value: string }>) =>
  txTypes.filter(({ value: txType }) => XIDR_BIZ_TX_TYPES.includes(txType))
